import http from '@/libs/axios'

export const PrizeDrawService = {
  /**
   * Importa arquivos de sorteio
   * @param {string} uuid
   * @param {boolean} canImportFile
   * @param {File} file
   */
  async importFile(uuid, canImportFile, file) {
    const data = new FormData()
    data.append('file', file)

    const endpoint = canImportFile ? 'import' : 'import-comments'
    return http.post(`prize-draws/${uuid}/${endpoint}`, data)
  },
}
